module.exports = __webpack_public_path__ + "img/close.494893ee.svg";